import { Currencies } from '@orbital/games-frontend-library'
import React, { useEffect, useState } from 'react'
import { ReactComponent as FoldSVG } from '../../../lib/assets/fold.svg'
import { AnimatedText } from './BetButtonsStyles'
import {
  sumNumbersWithString,
  formatThousandWithDecimals,
  round,
} from '../helpers/helperChip'

export const BetButtonText = (
  ante: string,
  AAbonus: string,
  currency: string,
  toFix: number,
  gameState: number,
) => {
  const [undoText, setUndoText] = useState<string>('Undo')
  const [dealText, setDealText] = useState<string>('Deal')

  const sum = (a: string, b: string, toFix: number) => {
    let sumAB
    if (a.toString().includes('k') || b.toString().includes('k')) {
      const sum = sumNumbersWithString(a, b)
      sumAB = formatThousandWithDecimals(+sum)
    } else sumAB = +round(+a + +b, toFix)
    return sumAB
  }

  const UNDO_TEXT = [
    {
      name: 'Fold',
      content: (
        <>
          <FoldSVG />
          <span>Fold</span>
        </>
      ),
    },
    {
      name: 'NewBet',
      content: <span>New Bets</span>,
    },
    {
      name: 'Undo',
      content: <span>Undo</span>,
    },
  ]

  const DEAL_TEXT = [
    {
      name: 'Raise',
      content: (
        <>
          <FoldSVG />
          <span>Raise</span>
        </>
      ),
    },
    {
      name: 'Rebet',
      content: (
        <>
          <span className='deal-rebet'>REBET</span>
          <span>{Currencies[currency]}</span>
          <span>{AAbonus !== 'AA' ? sum(ante, AAbonus, toFix) : ante}</span>
        </>
      ),
      // content: `REBET ${Currencies[currency]}${stake}`,
    },
    {
      name: 'Deal',
      content: (
        <>
          <span className='deal-rebet'>DEAL</span>
          <span>{Currencies[currency]}</span>
          <span>{AAbonus !== 'AA' ? sum(ante, AAbonus, toFix) : ante}</span>
        </>
      ),
    },
  ]

  const handleBtnContent = (st: number) => {
    switch (st) {
      case 4:
        setDealText('Raise')
        setUndoText('Fold')
        break
      case 5:
      case 6:
      case 11:
        setDealText('Rebet')
        setUndoText('NewBet')
        break
      default:
        setDealText('Deal')
        setUndoText('Undo')
        break
    }
  }
  useEffect(() => {
    handleBtnContent(gameState)
  }, [gameState])

  const UNDO = UNDO_TEXT.map((item, id) => (
    <AnimatedText fadeIn={undoText === item.name} key={id}>
      {item.content}
    </AnimatedText>
  ))
  const DEAL = DEAL_TEXT.map((item, id) => (
    <AnimatedText fadeIn={dealText === item.name} key={id}>
      {item.content}
    </AnimatedText>
  ))
  return { UNDO, DEAL }
}
